import React from "react";

const Loading = () => {
  return (
    <div className="flex items-center justify-center h-screen w-screen bg-[#0f0f13]">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-pink-500"></div>
    </div>
  );
};

export default Loading;
